export class CreateIssueStateError extends Error {
    
}